// extracted by mini-css-extract-plugin
export default {"cls1":"qtg0Dvk8VpCkbjLLbLGk","cls2":"ZVH6Q4V2Xazxcnu0rYE0 qtg0Dvk8VpCkbjLLbLGk"};